import { FormBuilder, IFormConfig } from '@fareye/form-builder'
import { AtLeastOne } from '@fareye/types'
import { Flex, toast } from '@fareye/ui'
import {
  cancelToken,
  isEmpty,
  post,
  put,
  unflattenChainedKeysStringToObject
} from '@fareye/utils'
import React from 'react'
import { IAlertConfig, IPageConfig } from '../../utility/types'
interface IFormRenderer {
  selectedAlertType: string
  formRenderingConfig: IFormConfig
  selectedAlert: any
  setSelectedAlert(val: any): void
  editingAlert?: any
  setEditingAlert?(val: any): void
  propsConfig: AtLeastOne<IPageConfig> | {}
  baseUrl: string
}
export function FormRenderer({
  selectedAlertType,
  formRenderingConfig,
  selectedAlert,
  setSelectedAlert,
  editingAlert,
  setEditingAlert,
  propsConfig,
  baseUrl
}: IFormRenderer) {
  const [formValue, setFormValue] = React.useState<any>({})
  const [isFormSubmitted, setFormSubmitted] = React.useState(false)
  const [formDefaultValue, setFormDefaultValue] = React.useState({
    type: selectedAlertType
  })

  const { apiURL } = ((propsConfig as IPageConfig).config as IAlertConfig)
    .apiConfig || {
    apiURL: ''
  }

  React.useEffect(() => {
    if (!isEmpty(formValue.values)) {
      const ans = unflattenChainedKeysStringToObject(formValue.values, '-')
      refactorFormForSubmit(ans)
      submitForm(ans, formValue.resetForm)
    }
  }, [formValue])

  React.useEffect(() => {
    setFormDefaultValue({ type: selectedAlertType })
    setEditingAlert && setEditingAlert(null)
  }, [selectedAlertType])

  React.useEffect(() => {
    if (editingAlert) {
      const settingsDefaults = Object.keys(editingAlert.settings || {}).reduce(
        (acc: any, key: string) => {
          const val = editingAlert.settings[key]
          if (key === 'poi_ids' && Array.isArray(val)) {
            acc[`settings-poi_ids`] = val.map((id: any) =>
              typeof id === 'object' && id !== null
                ? id
                : { id, poi_nick_name: String(id) }
            )
          } else {
            acc[`settings-${key}`] =
              val !== null && val !== undefined
                ? { value: val, label: String(val) }
                : null
          }
          return acc
        },
        {}
      )
      setFormDefaultValue({
        type: selectedAlertType,
        is_consolidated: editingAlert.is_consolidated,
        is_enabled: editingAlert.is_enabled,
        providers: editingAlert.providers,
        alert_users: editingAlert.alert_users,
        ...settingsDefaults
      })
    } else {
      setFormDefaultValue({ type: selectedAlertType })
    }
  }, [editingAlert])

  function refactorFormForSubmit(ans: any) {
    try {
      Object.keys(ans).map(ele => {
        if (
          ans[ele] &&
          typeof ans[ele] === 'object' &&
          ele === 'carrier_code'
        ) {
          ans[ele] = ans[ele]['scac'] || ans[ele]
        }
        if (
          ans[ele] &&
          typeof ans[ele] === 'object' &&
          ele === 'new_alert_users'
        ) {
          ans[ele].map((values: any) => {
            values['user_timezone'] = values['user_timezone']
              ? values['user_timezone']['utc'][0]
              : ''
            return values
          })
        }
        if (
          ans[ele] &&
          typeof ans[ele] === 'object' &&
          !Array.isArray(ans[ele]) &&
          !ans[ele].value
        ) {
          refactorFormForSubmit(ans[ele])
        }if (ans[ele]?.value === 0) {
          ans[ele] = ans[ele].value
      } else if (ans[ele] && ans[ele].value!=undefined && ans[ele].value !== null) {
          ans[ele] = ans[ele].value
        } else if (
          Array.isArray(ans[ele]) &&
          ans[ele][0] &&
          ans[ele][0]['poi_nick_name']
        ) {
          ans[ele] = ans[ele].map((ele: any) => ele.id)
        } else if (
          Array.isArray(ans[ele]) &&
          ans[ele][0] &&
          [
            'location_type',
            'location_codes',
            'event',
            'container_event_type'
          ].includes(ele)
        ) {
          ans[ele] = ans[ele].map((ele: any) => ele.value)
        }
      })
    } catch (ex:any) {}
  }
  async function submitForm(val: any, resetForm?: any) {
    try {
      setFormSubmitted(true)
      const isEditing = !!(editingAlert && editingAlert.id)
      const url = isEditing ? `${apiURL}/${editingAlert.id}` : apiURL
      const resp = isEditing
        ? await put(url, val, cancelToken().source().token, {
            validateStatus: (status: number) => true
          })
        : await post(url, val, cancelToken().source().token, {
            validateStatus: (status: number) => true
          })
      if (resp.status > 300) {
        const error: any = new Error()
        const error_message = resp.data.error_message
          ? resp.data.error_message
          : resp.data.error
        if (error_message && resp.status != 500) {
          error.response = { data: { error_message: error_message } }
        }
        throw error
      }
      toast.success(
        resp.data?.message ||
          (isEditing ? 'Alert updated successfully' : 'Alert created successfully')
      )
      setFormSubmitted(false)
      setEditingAlert && setEditingAlert(null)
      setFormDefaultValue({ type: selectedAlertType })
      resetForm && resetForm()
      setSelectedAlert(resp.data)
    } catch (ex:any) {
      setFormSubmitted(false)
      try {
        const {
          data: { error_message }
        } = ex.response
        toast.error(error_message)
      } catch (ex:any) {
        toast.error(
          "Please check you've filled all the required input values and user."
        )
      }
    }
  }

  return (
    <Flex column bg="#fff" style={{ marginBottom: 10 }}>
      <FormBuilder
        setSubmitValues={setFormValue}
        formDefaultValue={formDefaultValue}
        config={formRenderingConfig}
        formGroupName={selectedAlertType}
        isLoading={isFormSubmitted}
        baseUrl={baseUrl}
        editingAlert={editingAlert}
        onReset={(resetForm) => {
          setEditingAlert && setEditingAlert(null)
          setFormDefaultValue({ type: selectedAlertType })
          resetForm()
        }}
      />
    </Flex>
  )
}
